//const API_BASE_URL = "https://samso-engage.ae-samsotechapp.com";

//const API_BASE_URL = "https://engage.rotana.site/DigitalAPI";
//const API_BASE_URL = "https://192.168.50.81:460/";
//const API_BASE_URL ="https://yaamava-kiosk.us-samsotechapp.com/dgjapi/";

//const API_BASE_URL ="https://192.168.50.81:1218";
//const API_BASE_URL ="https://192.168.50.81:460/";

// const API_BASE_URL ="http://10.5.23.170:8091/"
//const API_BASE_URL ="http://192.168.52.184:7222/"

//const API_BASE_URL = "http://192.168.52.114:850/";
//const API_BASE_URL = process.env.REACT_APP_API_BASE_URL
//const API_BASE_URL ="http://192.168.52.184:2345/dgj"

//const API_BASE_URL = "https://yaamava-kiosk.us-samsotechapp.com/dgjapi";

//const API_BASE_URL = "http://localhost:8092";
//export const API_BASE_URL2 = "http://localhost:4000/";



//export const API_BASE_URL2 = process.env.REACT_APP_API_BASE_URL2;
const API_BASE_URL ="http://localhost:44373/"  //DGJ API Url
export const API_BASE_URL2 = "http://localhost:8443/";//  Scanner API URL
export const AUTO_LOGIN_USERNAME = "AUTO_LOGIN_USERNAME";//set as AUTO_LOGIN_USERNAME for production
export const AUTO_LOGIN_PASSWORD = "AUTO_LOGIN_PASSWORD";//set as AUTO_LOGIN_PASSWORD for production
export const CHECKIN_PRINTER_NAME = "CHECKIN_PRINTER_NAME";//set as CHECKIN_PRINTER_NAME for production
export const CHECKOUT_PRINTER_NAME = "CHECKOUT_PRINTER_NAME";//set as CHECKOUT_PRINTER_NAME for production
export const DEMO_MODE = false;

//export const API_BASE_URL2 = "http://192.168.52.114:8443/";//  Sreelakshmi Scanner API URL

//export const API_BASE_URL2 = "http://192.168.52.135:8443/";//shajana 

//kiosk server

export const API_URL = API_BASE_URL;
